/**
 * Created by adalto on 6/3/14.
 * Classe para o modal de informações relacionadas
 */


Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = {

    collections: {
        DRIVERS: {
            name: 'drivers',
            model: 'user',
            containerIdSelector: 'relatedLinksDriverItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createUserInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksDriversTitle', 'Task.DriversList.Title')
        },
        ROUTES: {
            name: 'routes',
            model: 'route',
            containerIdSelector: 'relatedLinksRouteItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createRouteInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksRouteTitle', 'Task.RouteList.Title')
        },
        SURVEYS: {
            name: 'surveys',
            model: 'survey',
            containerIdSelector: 'relatedLinksSurveyItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createSurveyInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksSurveysTitle', 'Task.SurveysList.Title')
        },
        EQUIPMENTS: {
            name: 'equipments',
            model: 'equipment',
            containerIdSelector: 'relatedLinksEquipmentItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createEquipmentInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksEquipmentsTitle', 'Task.EquipmentList.Title')
        },
        LOCATIONS: {
            name: 'locations',
            model: 'location',
            containerIdSelector: 'relatedLinksLocationItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createLocationInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksLocationTitle', 'Task.LocationList.Title')
        },
        ANOTHER_TASK: {
            name: 'anotherTask',
            model: 'anotherTask',
            containerIdSelector: 'relatedLinksAnotherTaskItems',
            createInfo: (item, id) => Greenmile.Task.RelatedInfo.createTaskInfo(item, id),
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksTaskTitle', 'Task.RelatedTasksList.Title')
        },
        ORDERS: {
            name: 'orders',
            model: 'order',
            containerIdSelector: 'relatedLinksOrderItems',
            createInfo: (item) => item,
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksOrderTitle', 'Task.Order.Title')
        },
        EVENTS: {
            name: 'events',
            model: 'eventLog',
            containerIdSelector: 'relatedLinksEventsItems',
            createInfoContainer: () =>
                Greenmile.Task.RelatedInfo
                    .createTemplateRelatedLinks('relatedLinksEventTitle', 'Task.EventList.Title')
        },
    },

    deleteTaskLinked: function (taskLinkedId, callback) {

        if (taskLinkedId) {

            var url = 'TaskLinked/' + taskLinkedId;
            var request = new Monet.Ajax();

            request.url = url;
            request.method = 'delete';

            request.success = function (data) {
                if (data === true) {
                    callback();
                }
            };

            request.send();
        } else {
            callback();
        }

    },

    createInfo: function (routeItem, id, url) {
        var link = document.createElement('a');
        var userInfoItem = document.createElement('div');
        var statusInput = routeItem.querySelector('input[name="taskLinkeds[' + id.value + '].status"]');

        if (statusInput) {
            statusInput.value = '';
        }

        if (url) {
            link.href = url + id.value;
        }

        link.appendChild(routeItem);

        userInfoItem.className = 'userListItem zebrado';
        userInfoItem.appendChild(link);

        return userInfoItem;
    },

    createRouteInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id, "#/Route/edit/");
    },

    createUserInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id, "#/Driver/edit/");
    },

    createEquipmentInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id, "#/Equipment/edit/");
    },

    createSurveyInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id, "#/Survey/edit/");
    },

    createLocationInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id, "#/Location/edit/");
    },

    createTaskInfo: function (routeItem, id) {
        return this.createInfo(routeItem, id);
    },

    createMapInfo: function (mapItem, node) {

        const userInfoItem = document.createElement('div');
        const statusInput = node.querySelector('input[name="maps[' + mapItem.id + '].status"]');
        const linkedID = node.querySelector('input[name="maps[' + mapItem.id + '].id"]');
        let divMap = null;
        const mapTaskRouteListLine = this.buildMapTaskRouteListContainer();

        if (statusInput) {
            statusInput.value = '';
        }

        if (linkedID && !mapItem.lastModificationDate) {
            var parentLId = linkedID.parentNode;
            parentLId.removeChild(linkedID);
        }

        if (mapItem.longitude) {

            divMap = document.createElement('div');
            divMap.id = 'formLinkMaps_' + mapItem.id;
            divMap.className = 'formLinkEventMaps';

            userInfoItem.appendChild(divMap);
        }

        userInfoItem.className = 'userListItem';
        userInfoItem.appendChild(node);
        userInfoItem.appendChild(mapTaskRouteListLine);

        return userInfoItem;
    },

    buildMapTaskRouteListContainer: function() {
        const mapTaskRouteListLine = document.createElement('div');
        const cloumnDesc = document.createElement('div');
        const cloumnDate = document.createElement('div');
        mapTaskRouteListLine.className = "GreenmileTaskRouteListLine";
        cloumnDesc.className = "GreenmileTaskRouteListCloumn";
        cloumnDate.className = "GreenmileTaskRouteListCloumn";

        mapTaskRouteListLine.appendChild(cloumnDesc);
        mapTaskRouteListLine.appendChild(cloumnDate);

        return mapTaskRouteListLine;
    },

    createEventInfo: function (routeItem, id, data) {

        var userInfoItem = document.createElement('div');
        var statusInput = routeItem.querySelector('input[name="taskLinkeds[' + id.value + '].status"]');
        var divMap = null;

        if (statusInput) {
            statusInput.value = '';
        }

        var eventLog = data.eventLog || data;

        if (eventLog.longitude) {

            divMap = document.createElement('div');
            divMap.id = 'formLinkEventMaps_' + eventLog.id;
            divMap.className = 'formLinkEventMaps';

            userInfoItem.appendChild(divMap);
        }

        userInfoItem.className = 'userListItem';
        userInfoItem.appendChild(routeItem);

        return userInfoItem;

    },

    closeLinkForm: function () {

        var form = document.getElementById('TaskManagerLinkForm');
        var overlay = document.getElementById('TaskManagerLinkOverlay');

        var parent = form.parentNode;
        parent.removeChild(form);

        var parentOverlay = overlay.parentNode;
        parentOverlay.removeChild(overlay);

    },

    createTemplateRelatedLinks: function (id, key) {

        return `<div class="relatedLinksContainer">
                    <div class="relatedLinks" id="${id}" >
                        <h2>${Monet.I18n.getResourcesByKey(key)}</h2>
                    </div>
                    <hr class="divider">
                    <p></p>
                </div>`;

    },

    updateRelatedInfoContent: function () {

        var relatedLinkInfo = document.getElementById('taskLinkInfoContainer');
        var btnLink = document.getElementById('btn_link_to_task');

        if (btnLink) {
            btnLink.removeAttribute('disabled');
        }

        if (relatedLinkInfo) {
            relatedLinkInfo.innerHTML = "";
        }

        if (Monet.Session.Task.lastLinkForm.maps && Monet.Session.Task.lastLinkForm.maps.ids.length > 0) {

            relatedLinkInfo.insertAdjacentHTML('beforeend',
                this.createTemplateRelatedLinks("relatedLinksMapTitle", 'Task.RelatedMapsList.Title'));

            Monet.Session.Task.lastLinkForm.maps.data.forEach(function (data, index) {
                var node = Monet.Session.Task.lastLinkForm.maps.nodes[index];
                relatedLinkInfo.appendChild(this.createMapInfo(data, node));
                Greenmile.Task.RelatedInfo.Map.addMapRelatedInfo(data);
            }, this);
        }

        if (Monet.Session.Task.lastLinkForm.routes.ids.length > 0) {

            const sectionRouteContainer = document.createElement('div');
            sectionRouteContainer.id = this.collections.ROUTES.containerIdSelector;
            
            sectionRouteContainer.insertAdjacentHTML('beforeend',
                this.collections.ROUTES.createInfoContainer());

            Monet.Session.Task.lastLinkForm.routes.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.routes.nodes[index];
                sectionRouteContainer.firstChild.appendChild(this.createRouteInfo(node, id));
            }, this);

            relatedLinkInfo.appendChild(sectionRouteContainer);
        }

        if (Monet.Session.Task.lastLinkForm.drivers.ids.length > 0) {

            const sectionDriverContainer = document.createElement('div');
            sectionDriverContainer.id = this.collections.DRIVERS.containerIdSelector;

            sectionDriverContainer.insertAdjacentHTML('beforeend',
                this.collections.DRIVERS.createInfoContainer());


            Monet.Session.Task.lastLinkForm.drivers.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.drivers.nodes[index];
                sectionDriverContainer.firstChild.appendChild(this.createUserInfo(node, id));
            }, this);

            relatedLinkInfo.appendChild(sectionDriverContainer);

        }

        if (Monet.Session.Task.lastLinkForm.surveys.ids.length > 0) {

            const sectionSurveyContainer = document.createElement('div');
            sectionSurveyContainer.id = this.collections.SURVEYS.containerIdSelector;

            sectionSurveyContainer.insertAdjacentHTML('beforeend',
                this.collections.SURVEYS.createInfoContainer());

             Monet.Session.Task.lastLinkForm.surveys.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.surveys.nodes[index];
                sectionSurveyContainer.firstChild.appendChild(this.createSurveyInfo(node, id));
            }, this);

             relatedLinkInfo.appendChild(sectionSurveyContainer);
        }

        if (Monet.Session.Task.lastLinkForm.equipments.ids.length > 0) {

            const sectionEquipmentsContainer = document.createElement('div');
            sectionEquipmentsContainer.id = this.collections.EQUIPMENTS.containerIdSelector;

            sectionEquipmentsContainer.insertAdjacentHTML('beforeend',
                this.collections.EQUIPMENTS.createInfoContainer());

            Monet.Session.Task.lastLinkForm.equipments.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.equipments.nodes[index];
                sectionEquipmentsContainer.firstChild.appendChild(this.createEquipmentInfo(node, id));
            }, this);

            relatedLinkInfo.appendChild(sectionEquipmentsContainer);

        }

        if (Monet.Session.Task.lastLinkForm.locations.ids.length > 0) {

            const sectionLocationContainer = document.createElement('div');
            sectionLocationContainer.id = this.collections.LOCATIONS.containerIdSelector;

            sectionLocationContainer.insertAdjacentHTML('beforeend',
                this.collections.LOCATIONS.createInfoContainer());

            Monet.Session.Task.lastLinkForm.locations.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.locations.nodes[index];
                sectionLocationContainer.firstChild.appendChild(this.createLocationInfo(node, id));
            }, this);

            relatedLinkInfo.appendChild(sectionLocationContainer);
        }

        if (Monet.Session.Task.lastLinkForm.anotherTask.ids.length > 0) {

            const sectionAnotherTaskContainer = document.createElement('div');
            sectionAnotherTaskContainer.id = this.collections.ANOTHER_TASK.containerIdSelector;

            sectionAnotherTaskContainer.insertAdjacentHTML('beforeend',
                this.collections.ANOTHER_TASK.createInfoContainer());

            Monet.Session.Task.lastLinkForm.anotherTask.ids.forEach(function (id, index) {
                const node = Monet.Session.Task.lastLinkForm.anotherTask.nodes[index];
                sectionAnotherTaskContainer.firstChild.appendChild(this.createTaskInfo(node, id));
            }, this);

            relatedLinkInfo.appendChild(sectionAnotherTaskContainer);

        }

        if (Monet.Session.Task.lastLinkForm.events.ids.length > 0) {

            const sectionContainer = document.createElement('div');
            sectionContainer.id = this.collections.EVENTS.containerIdSelector;

            sectionContainer.insertAdjacentHTML('beforeend',
                this.collections.EVENTS.createInfoContainer());

            relatedLinkInfo.appendChild(sectionContainer);

            Monet.Session.Task.lastLinkForm.events.ids.forEach(function (id, index) {
                var data = Monet.Session.Task.lastLinkForm.events.data[index];
                var node = Monet.Session.Task.lastLinkForm.events.nodes[index];

                sectionContainer.firstChild.appendChild(this.createEventInfo(node, id, data));
                var eventLog = data.eventLog || data;

                if (eventLog.latitude) {
                    Greenmile.Task.RelatedInfo.Event.addMapToEventInfo(eventLog);
                }

                const selector = `#event_list_line_${id.value}`;
                const $task = $("#Task");
                const tooltip = {
                    selector,
                    showEvent: () => {
                      const eventWindow = new Greenmile.EventNotifications.Window();
                      const eventLog = new App.Models.EventLog();
                      eventWindow.getEventData(eventLog, id.value, selector);
                    },
                    viewport: $task,
                    container: $task,
                    target: '#page_container',
                    my: "center center",
                    at: "center center",
                    width: 350
                };

                Monet.Tooltip.addTooltip(tooltip);

            }, this); 

        }

        if (Monet.Session.Task.lastLinkForm.orders.ids.length) {

            const sectionOrderContainer = document.createElement('div');
            sectionOrderContainer.id = this.collections.ORDERS.containerIdSelector;

            sectionOrderContainer.insertAdjacentHTML('beforeend',
                this.collections.ORDERS.createInfoContainer());

            Monet.Session.Task.lastLinkForm.orders.ids.forEach(function (_, index) {
                sectionOrderContainer.firstChild.appendChild(
                    Monet.Session.Task.lastLinkForm.orders.nodes[index]
                );
            });

            relatedLinkInfo.appendChild(sectionOrderContainer);
      }

        this.renderAgrupedTaskLinkeds(
            Monet.Session.Task.lastLinkForm.agruped,
            relatedLinkInfo
        );

    },

    createLinkInfoContainers: function (crudStage) {

        var selector = '#Task div[key="new_form_task_layout_link_btn"]';
        var taskForm;
        var divContainer;

        if (crudStage === 'edit') {
            selector = '#Task div[key="edit_form_task_layout_link_btn"]';
        }

        taskForm = document.querySelector(selector);
        divContainer = document.createElement('div');

        divContainer.id = 'taskLinkInfoContainer';

        if (taskForm) {
            taskForm.appendChild(divContainer);
        }

    },

    addLinkFormListeners: function () {
        var filterRouteBtn = document.getElementById('transferStopBtnSearchRoute');
        var filterEventsBtn = document.querySelector('#taskManager-event #btnFilterEventos');
        var filterClearEventsBtn = document.querySelector('#taskManager-event #btnFilterClear');
        var saveBtns = Array.prototype.slice.call(document.querySelectorAll('input[name="taskManagerPopupSave"]'), 0);
        var cancelBtns = Array.prototype.slice.call(document.querySelectorAll('input[name="taskManagerPopupCancel"]'), 0);
        var relateInfo;

        filterRouteBtn.addEventListener('click', function () {

            relateInfo = Greenmile.Task.RelatedInfo.Route;

            if (relateInfo.validateRouteForm()) {
                relateInfo.searchRoute();
            }

        });

        filterEventsBtn.addEventListener('click', function () {

            relateInfo = Greenmile.Task.RelatedInfo.Event;

            relateInfo.overwriteFilterEvents();

        });

        filterClearEventsBtn.addEventListener('click', function () {

            var selectedEvents = document.querySelector('.taskEventsFiltered');

            App.Forms.TabEventEquipmentLookup.lookupElement.clear();
            App.Forms.EventRouteLookup.lookupElement.clear();
            App.Forms.StopLookup.lookupElement.clear();
            App.Forms.EventLookup.lookupElement.clear();

            selectedEvents.innerHTML = '';

        });

        saveBtns.forEach(function (button) {

            button.addEventListener('click', (function (scope) {

                return function () {
                    scope.getLinkFormData();
                    var opts = { state: 'CREATE' };

                    Greenmile.Task.RelatedInfo.Driver.createFullDriverInfo(Monet.Session.Task.newTask.drivers);
                    Greenmile.Task.RelatedInfo.Equipment.createFullEquipmentInfo(Monet.Session.Task.newTask.equipments);
                    Greenmile.Task.RelatedInfo.Survey.createFullSurveyInfo(Monet.Session.Task.newTask.surveys);
                    Greenmile.Task.RelatedInfo.Location.createFullLocationInfo(Monet.Session.Task.newTask.locations);
                    Greenmile.Task.RelatedInfo.Task.createFullTaskInfo(Monet.Session.Task.newTask.anotherTask);
                    Greenmile.Task.RelatedInfo.Route.createFullRouteInfo(Monet.Session.Task.newTask.routes);
                    Greenmile.Task.RelatedInfo.Event.createFullEventInfo(Monet.Session.Task.newTask.events);
                    Greenmile.Task.RelatedInfo.Order.createFullOrderInfo(Monet.Session.Task.newTask.orders);
                    Greenmile.Task.RelatedInfo.updateRelatedInfoContent(opts);

                };

            }(this)));

        }, this);

        cancelBtns.forEach(function (button) {

            button.addEventListener('click', (function (scope) {

                return function () {
                    var opts = { state: 'UPDATE' };

                    scope.closeLinkForm();
                    Greenmile.Task.RelatedInfo.updateRelatedInfoContent(opts);

                };

            }(this)));

        }, this);

        App.Forms.DriverLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
            App.Forms.DriverLookupList, 'drivers', 'user'
        );
        App.Forms.SurveyLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
            App.Forms.SurveyLookupList, 'surveys', 'survey'
        );
        App.Forms.EquipmentLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
            App.Forms.EquipmentLookupList, 'equipments', 'equipment'
        );
        App.Forms.LocationLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
            App.Forms.LocationLookupList, 'locations', 'location'
        );
        App.Forms.TaskLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
            App.Forms.TaskLookupList, 'anotherTask', 'anotherTask'
        );
        App.Forms.OrderLookupList.lookupElement.destroyItem = this.removeItemsFromLookup(
          App.Forms.OrderLookupList, 'orders', 'order'
        );

    },

    setLinkFormData: function () {

        if (Monet.Session.Task.lastLinkForm.routes) {
            Monet.Session.Task.lastLinkForm.routes.data.forEach(function (route) {
                Greenmile.Task.RelatedInfo.Route.addItemToRouteList(route.route);
            });
        }

        if (Monet.Session.Task.lastLinkForm.drivers) {
            Monet.Session.Task.lastLinkForm.drivers.data.forEach(function (driver) {
                App.Forms.DriverLookupList.lookupElement.setValue([driver.user]);
            });
        }

        if (Monet.Session.Task.lastLinkForm.surveys) {
            Monet.Session.Task.lastLinkForm.surveys.data.forEach(function (survey) {
                App.Forms.SurveyLookupList.lookupElement.setValue([survey.survey]);
            });
        }

        if (Monet.Session.Task.lastLinkForm.equipments) {

            Monet.Session.Task.lastLinkForm.equipments.data.forEach(function (equipment) {
                App.Forms.EquipmentLookupList.lookupElement.setValue([equipment.equipment]);
            });
        }

        if (Monet.Session.Task.lastLinkForm.locations) {
            Monet.Session.Task.lastLinkForm.locations.data.forEach(function (location) {
                App.Forms.LocationLookupList.lookupElement.setValue([location.location]);
            });
        }

        if (Monet.Session.Task.lastLinkForm.events) {
            var event = Greenmile.Task.RelatedInfo.Event;
            Monet.Session.Task.lastLinkForm.events.data.forEach(function (eventLinked) {
                var element = event.renderItemToEventLogList(eventLinked.eventLog);
                event.addInSelectedEventList(element, element.querySelector('.table-action-destroylink'), event);
            });
        }

        if (Monet.Session.Task.lastLinkForm.anotherTask) {
            Monet.Session.Task.lastLinkForm.anotherTask.data.forEach(function (task) {
                App.Forms.TaskLookupList.lookupElement.setValue([task.anotherTask]);
            });
        }

        if (Monet.Session.Task.lastLinkForm.orders) {
          Monet.Session.Task.lastLinkForm.orders.data.forEach(function (task) {
              App.Forms.OrderLookupList.lookupElement.setValue([task.order]);
          });
        }

    },

    removeItemsFromLookup: function (contextLookup, collection, model) {

        return function (nodeElement) {

            var taskLinkedId = null;
            var indexOnNameSpace = null;

            Monet.Session.Task.lastLinkForm[collection].data.forEach(function (element, index) {

                if (element[model].id.toString() === nodeElement.id) {

                    taskLinkedId = element;
                    indexOnNameSpace = index;

                    return null;
                }

            });

            var removeFromLookup = function () {

                contextLookup.lookupElement.removeItemFromListValue(nodeElement.id);
                contextLookup.lookupElement.divLookupListWrapper.removeChild(nodeElement);

            };

            var callback = function () {

                removeFromLookup();

                Monet.Session.Task.lastLinkForm[collection].data.splice(indexOnNameSpace, 1);
                Monet.Session.Task.lastLinkForm[collection].ids.splice(indexOnNameSpace, 1);
                Monet.Session.Task.lastLinkForm[collection].nodes.splice(indexOnNameSpace, 1);

            };

            if (taskLinkedId) {
                Greenmile.Task.RelatedInfo.deleteTaskLinked(taskLinkedId.id, callback);
            } else {
                removeFromLookup();
            }

        };
    },

    

    createLinkForms: function () {

        var formOverlay = document.getElementById('TaskManagerLinkForm');
        formOverlay.appendChild((new Monet.UI.LayoutGenerator(
          Greenmile.Task.RelatedInfoTemplate.createFormTemplate()
        )).render());
        
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-driver');
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-equipment');
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-location');
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-task');
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-survey');
        Monet.FormBuilder.Utils.upgradeLookupsToMonet2('TaskManagerLinkForm', ' #taskManager-route');
        Monet.FormBuilder.Utils.upgradeLookupsToMonet2('TaskManagerLinkForm', ' #taskManager-event');
        Monet.FormBuilder.Utils.upgradeLookupsListToMonet2('TaskManagerLinkForm', ' #taskManager-order');

        $("#taskManagerTabs").tabs();

        $('#taskManager-route #routeDate').datepicker({ dateFormat: Monet.I18n.locale.dateFormat.toLowerCase().replace("yyyy", "yy") });

        this.addLinkFormListeners();
        this.setLinkFormData();
        this.updateBodyRequestLookupLocation();
    },

    updateBodyRequestLookupLocation: function () {
        var defaultCriteriaForFields = {
            criteriaChain: [
                {
                    and: [
                        { "attr": "enabled", "eq": true }
                    ]
                }
            ]
        };

        App.Forms.LocationLookupList.lookupElement.setRequestBody(defaultCriteriaForFields);
    },

    createLinkFormOverlay: function () {

        var popupEl = document.querySelector('#Task .span10');
        var linkFormOverlay = document.createElement('div');
        var linkFormContent = document.createElement('div');

        linkFormOverlay.id = 'TaskManagerLinkOverlay';
        linkFormContent.id = 'TaskManagerLinkForm';

        popupEl.appendChild(linkFormOverlay);
        popupEl.appendChild(linkFormContent);

        this.createLinkForms();

    },

    getLinkFormData: function () {

        var form = document.getElementById('TaskManagerLinkForm');
        var overlay = document.getElementById('TaskManagerLinkOverlay');
        var routesNodes = Array.prototype.slice.call(document.querySelectorAll('#route_list .GreenmileTaskRouteListLine'), 0);
        var events = Array.prototype.slice.call(document.querySelectorAll('.taskEventsSelected input[type="hidden"].eventLogId'), 0);
        var eventsNodes = Array.prototype.slice.call(document.querySelectorAll('.taskEventsSelected > div'), 0);
        var parent, parentOverlay;

        Monet.Session.Task.newTask.drivers = [];
        Monet.Session.Task.newTask.surveys = [];
        Monet.Session.Task.newTask.equipments = [];
        Monet.Session.Task.newTask.locations = [];
        Monet.Session.Task.newTask.anotherTask = [];
        Monet.Session.Task.newTask.orders = [];

        var addItemsToNewTask = function (collection, model, elementToAdd) {
            var obj = Monet.Session.Task.lastLinkForm[collection].data.filter(function (element) {
                return element[model].id === elementToAdd.id;
            })[0];

            if (!obj) {
                obj = {};
                obj[model] = {};
                obj[model].id = elementToAdd.id;

                if (model === 'anotherTask') {

                    obj[model].title = elementToAdd.title;

                } else if (model === 'route') {

                    obj[model].key = elementToAdd.key;
                    obj[model].date = elementToAdd.date;
                    obj[model].organization = {
                        description: elementToAdd.organization.description
                    };

                } else if (model === 'eventLog') {
                    
                    obj[model].timeValuedTrue = elementToAdd.timeValuedTrue;
                    obj[model].messageBody = elementToAdd.messageBody;
                    obj[model].latitude = elementToAdd.latitude;
                    obj[model].longitude = elementToAdd.longitude;
                    obj[model].stopLatitude = elementToAdd.stopLatitude;
                    obj[model].stopLongitude = elementToAdd.stopLongitude;
                    obj[model].icon = elementToAdd.icon;

                } else if(model === 'survey') {
                    obj[model].title = elementToAdd.title;
                } else if(model === 'order') {
                    obj[model].number = elementToAdd.number;
                } else {
                    obj[model].key = elementToAdd.key;
                }
            }

            Monet.Session.Task.newTask[collection].push(obj);

        };

        App.Forms.DriverLookupList.lookupElement.getFullValue().forEach(function (user) {
            addItemsToNewTask('drivers', 'user', user);
        });

        App.Forms.SurveyLookupList.lookupElement.getFullValue().forEach(function (survey) {
            addItemsToNewTask('surveys', 'survey', survey);
        });

        App.Forms.EquipmentLookupList.lookupElement.getFullValue().forEach(function (equipment) {
            addItemsToNewTask('equipments', 'equipment', equipment);
        });

        App.Forms.LocationLookupList.lookupElement.getFullValue().forEach(function (location) {
            addItemsToNewTask('locations', 'location', location);
        });

        App.Forms.TaskLookupList.lookupElement.getFullValue().forEach(function (task) {
            addItemsToNewTask('anotherTask', 'anotherTask', task);
        });

        App.Forms.OrderLookupList.lookupElement.getFullValue().forEach(function (order) {
          addItemsToNewTask('orders', 'order', order);
        });

        Monet.Session.Task.newTask.routes = [];
        routesNodes.forEach(function (element) {

            var route = {
                id: parseInt(element.querySelector('input[type="hidden"]').value, 10),
                key: element.childNodes[1].innerHTML,
                date: Monet.Format.Date.parseLocaleToISOString(element.childNodes[2].innerHTML),
                organization: {
                    description: element.childNodes[0].innerHTML
                }
            };

            addItemsToNewTask('routes', 'route', route);
        });

        Monet.Session.Task.newTask.events = [];
        events.forEach(function (event, index) {

            var eventsNode = eventsNodes[index];
            var eventLog = {
                id: parseInt(event.value, 10),
                timeValuedTrue: Monet.Format.Date.parseLocaleToISOString(eventsNode.firstChild.lastChild.innerHTML),
                messageBody: eventsNode.firstChild.firstChild.innerHTML,
                latitude: eventsNode.getAttribute('latitude'),
                longitude: eventsNode.getAttribute('longitude'),
                stopLatitude: eventsNode.getAttribute('stopLatitude'),
                stopLongitude: eventsNode.getAttribute('stopLongitude'),
                icon: eventsNode.getAttribute('icon')
            };

            addItemsToNewTask('events', 'eventLog', eventLog);

        }, this);

        parent = form.parentNode;
        parent.removeChild(form);

        parentOverlay = overlay.parentNode;
        parentOverlay.removeChild(overlay);

    },

    showAlertToConfirm: function(confirmCallback, resourceKey) {
        const resource = resourceKey || 'lookuplist.message.alertExclude';
        new Greenmile.Components.AlertModal(resource,
            null,
            confirmCallback)
        .show();
    },

    createTaskInformation: function (taskData) {
        const links = taskData[0].taskLinkeds;
        const maps = taskData[0].maps;

        const propertyExistIn = taskLinkKey => collection => 
            taskLinkKey === collection.model;

        const ifSomePropertyExist = taskLinkKey =>
            Object.values(this.collections).some(propertyExistIn(taskLinkKey));

        const taskLinksByProperty = taskLink =>
            Object.keys(taskLink).filter(ifSomePropertyExist);

        if (links?.length) {
            const linkedTasksWithKeysToCheck = links.map(taskLinksByProperty);
            const createAgrupedsTaskLinkeds = (linkedTaskKeys, index) => {
                if (linkedTaskKeys?.length > 1) {
                    Greenmile.Task.RelatedInfo.Agruped.createFullAgrupedInfo(links, index);
                }
            };

            linkedTasksWithKeysToCheck.forEach(createAgrupedsTaskLinkeds);

            const linkedTasksWithoutAgruped = links.filter(link => {
                const taskLinksByModel = taskLinksByProperty(link);

                return taskLinksByModel.length === 1;
            });

            Greenmile.Task.RelatedInfo.Route.createFullRouteInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Equipment.createFullEquipmentInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Driver.createFullDriverInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Location.createFullLocationInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Survey.createFullSurveyInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Event.createFullEventInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Order.createFullOrderInfo(linkedTasksWithoutAgruped);
            Greenmile.Task.RelatedInfo.Task.createFullTaskInfo(linkedTasksWithoutAgruped);
        }

        if (maps?.length) {
            Greenmile.Task.RelatedInfo.Map.createFullMapsInfo(maps);
        }

        this.updateRelatedInfoContent();
        Greenmile.Task.RelatedInfo.taskId = taskData[0].id;
    },

    renderAgrupedTaskLinkeds: function (lastLinkForm, relatedLinkInfoContainer) {
        if (lastLinkForm?.ids?.length > 0) {

            lastLinkForm.models.forEach((collection, index) => {
                const nodeEl = lastLinkForm.nodes[index];
                const idEl = lastLinkForm.ids[index];
                const infoContainer = collection.createInfo(nodeEl, idEl);
                const containerIdSelector = collection.containerIdSelector;
                const relatedLinkInfoContainerExist = relatedLinkInfoContainer.querySelector(
                    `#${containerIdSelector}`
                );
                
                if (relatedLinkInfoContainerExist) {

                    relatedLinkInfoContainerExist.firstChild.appendChild(infoContainer);

                } else {
                    const sectionContainer = document.createElement('div');
                    sectionContainer.id = containerIdSelector;

                    sectionContainer.insertAdjacentHTML('beforeend',
                        collection.createInfoContainer());

                    sectionContainer.firstChild.appendChild(infoContainer);

                    relatedLinkInfoContainer.appendChild(sectionContainer);
                }

            });
        }
    },

    removeTaskLinkedAsAgruped: function (data, callback) {

        if (data.id) {

            data.task = {
                id: Greenmile.Task.RelatedInfo.taskId
            };

            const url = 'TaskLinked/' + data.id;
            const request = new Monet.Ajax();

            request.url = url;
            request.method = 'PUT';
            request.data = data;

            request.success = function (data) {
                if (data === true) {
                    callback();
                }
            };

            request.send();
        } else {
            callback();
        }
    },

    removeTitleContainerIfEmptyTo: function(collection) {
        const haveMoreNodes = document.querySelectorAll(
            `#${collection.containerIdSelector} .userListItem.zebrado`
        );

        if (haveMoreNodes.length === 0) {
            const container = document.getElementById(
                collection.containerIdSelector
            );
            container.remove();
        }
    }
};
